import { createTag } from '@frontend/api-client/utils';
import type { BaseApi } from '@frontend/api-client/utils/types';
import type { ListSuggestionsParams, ListSuggestionsResponse, RetrieveSuggestionResponse } from '@frontend/api-types';
import { convertArrayObjectKeysCase, convertObjectKeysCase } from '@frontend/duck-tape';
import SUGGESTIONS_ENDPOINTS from './endpoints';

export const getSuggestionsApi = (baseApi: BaseApi) =>
  baseApi.injectEndpoints({
    endpoints: (builder) => ({
      listSuggestions: builder.query<ListSuggestionsResponse, ListSuggestionsParams | void>({
        providesTags: [createTag({ id: 'LIST', type: 'Suggestion' })],
        query: (params) => ({
          params: params?.view ? { view: params.view } : undefined,
          url: SUGGESTIONS_ENDPOINTS.listSuggestions(),
        }),
        transformResponse: (response: GenericRecord[]) =>
          convertArrayObjectKeysCase(response, 'camelCase') as ListSuggestionsResponse,
      }),
      retrieveSuggestion: builder.query<RetrieveSuggestionResponse, string>({
        providesTags: (_result, _error, id) => [createTag({ id, prefix: 'suggestionId', type: 'Suggestion' })],
        query: (id) => ({
          url: SUGGESTIONS_ENDPOINTS.retrieveSuggestion(id),
        }),
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as RetrieveSuggestionResponse,
      }),
    }),
    overrideExisting: true,
  });
